import { Truck } from './truck.model';

export interface User {
  id: number;
  name: string;
  phone: string;
  lastTimeSeen: string;
  lastLngLat: [number, number];
  activeSession: boolean;
  lastUsedTruck: Truck;
  deleted: boolean;
  userStatus: UserStatus;
}

export interface UserStatus {
  userId: number;
  type: 'Unreachable' | 'Online' | 'Offline' | 'Action Needed';
  shortTitle: string;
  isException: boolean;
  exceptionTitle: string;
  exceptionDescription: string;
  exceptionUrl: string;
  lastTimeSeen: string;
  lastLngLat: [number, number];
  shiftEndTimestamp: string;
  currentOrderId: number | null;
  isReusable: boolean;
}

export function isUnreachable(userStatus: UserStatus): boolean {
  return userStatus?.type === 'Unreachable';
}

export function isOnline(userStatus: UserStatus): boolean {
  return userStatus?.type === 'Online';
}
